import { Component, EventEmitter, Output } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from '../../core/services/auth/auth';
import { NavigationEnd, Router } from '@angular/router';
import { MatDivider } from '@angular/material/divider';
import { Profile } from '../../core/models/users.interface';
import { ChangePassword } from '../../features/components/change-password/change-password';
import { MatDialog } from '@angular/material/dialog';
import { ProfileService } from '../../core/services/profile/profile';
import { GroupService } from '../../core/services/group/group';
import { LayoutService } from '../../core/services/layout/layout';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-toolbar',
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDivider,
    MatSelectModule,
  ],
  templateUrl: './toolbar.html',
  styleUrl: './toolbar.scss',
})
export class Toolbar {
  @Output() toggleMenu = new EventEmitter<void>();
  ruta!: string;
  profile: Profile | null = null;
  grupoLogueado: string | null = null;
  sectorSelected: number | null = null;
  sectorNameSelected: string | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private profileService: ProfileService,
    private groupService: GroupService,
    private layoutService: LayoutService,
  ) {}

  ngOnInit(): void {
    this.ruta = this.router.url;
    this.profileService.userProfile$.subscribe((profile) => {
      this.profile = profile;
      this.grupoLogueado = this.groupService.getFirstGroup(profile);
      if (profile?.user_sector?.length) {
        this.sectorSelected = profile.user_sector[0].sector.id;
        this.sectorNameSelected = profile.user_sector[0].sector.name;
        this.layoutService.setSectorSelected({
          id: this.sectorSelected,
          name: this.sectorNameSelected,
        });
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.layoutService.setSearch(null);
        this.ruta = event.url;
      }
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['']);
  }

  changePassword(profile: Profile) {
    if (profile) {
      const dialogRef = this.dialog.open(ChangePassword, {
        data: { selectedProfile: profile },
        width: '90%',
        maxWidth: '700px',
        minWidth: '320px',
        maxHeight: '90vh',
        autoFocus: false,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe(() => {});
    }
  }

  changeSector(sectorId: number): void {
    const selectedSector = this.profile?.user_sector?.find((item) => item.sector.id === sectorId);
    if (!selectedSector) {
      return;
    }
    const sector = selectedSector.sector;
    this.sectorSelected = sector.id;
    this.layoutService.setSectorSelected({
      id: sector.id,
      name: sector.name,
    });
  }

  get shortenRoute(): string {
    return this.ruta?.length > 50 ? this.ruta.substring(0, 50) + '...' : this.ruta || '';
  }
}
